import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useTenantSafe } from '../context/TenantContext';
import HarvestSetupTab from '../components/harvesting/HarvestSetupTab';
import { canStaffSection } from '../utils/staffAccess';

// Admin-only settings page for the harvesting module's category/species/coded-list
// taxonomy. Reached from the Harvesting nav dropdown rather than buried in the
// general Community Admin tab bar.
export default function HarvestSetupPage() {
  // Works inside TenantProvider (/t/:slug/harvesting-setup) and standalone (/harvesting-setup)
  const tenantCtx = useTenantSafe();
  const { activeTenant, user } = useAuth();

  const viewTenant    = tenantCtx?.viewTenant || activeTenant;
  const tenantId      = viewTenant?._id;
  const tenantLoading = tenantCtx ? tenantCtx.loading : false;
  const tenantError   = tenantCtx ? tenantCtx.error : null;

  const canConfigure = canStaffSection(user, tenantId, 'harvesting');

  if (tenantLoading) {
    return (
      <div className="page community-admin-page">
        <p className="page-loading">Loading community…</p>
      </div>
    );
  }

  if (tenantError || !tenantId) {
    return (
      <div className="page community-admin-page">
        <p className="page-loading">{tenantError || 'Community not found.'}</p>
      </div>
    );
  }

  if (!canConfigure) {
    return (
      <div className="page community-admin-page">
        <p className="page-loading">Harvesting staff access is required to manage collection settings.</p>
      </div>
    );
  }

  return (
    <div className="page community-admin-page">
      <h2>Harvest Setup — {viewTenant?.branding?.displayName || viewTenant?.name}</h2>
      <HarvestSetupTab tenantId={tenantId} />
    </div>
  );
}
